import EventActionProto from '../event-action-proto';
import CrmAccountCollectionSession from "../../model2/crm/account/session/collection-session";

export default class SessionCrmAccount extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);

        this.method = sessionEvent.method;
        this.fromSID = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        switch (this.method) {
            case 'reset': gd.session._crmAccounts = new CrmAccountCollectionSession(this.data); break;
            default:
                this._updateSessionCollection();
                this._sendBusUpdate();
                break;
        }

        this._resetFieldOptions();
    }

    /**
     * FieldCrmAccount builds its options from the session collection once and caches them
     * (getOptions), so an account created, renamed or deleted after that would never resolve -
     * _getOption() finds nothing and the field renders empty. Every change to the collection
     * lands here, so this is where the cache is dropped. Same as the CRM contact fields.
     */
    _resetFieldOptions() {
        if (!gd.fields || !gd.fields.task) return;

        gd.fields.task.crmAccountId._options = null;
    }

    _updateSessionCollection() {
        // if user never initialized session.crmContacts we don't update it
        if (!gd.session.crmAccounts) return false;

        gd.session.crmAccounts.applyDelta(this.method, this.data);
    }

    _sendBusUpdate() {
        // send
        gd.modelBus.newUpdate('crm-account', this.method, this.data.id, this.data);
    }
}
